import styled from 'styled-components/macro';
import { TextField, Grid } from '@material-ui/core';
import OTSelect from '../../../components/engine/SelectEngine';

export const NumberInput = styled(TextField)`
  && {
    margin-left: 0.4em;
  }
  text-align: center;
  vertical-align: middle !important;
  width: 4rem;
  & input {
    height: 1.1em;
    text-align: center;
  }
`;

export const AdditionalSettingsGrid = styled(Grid)`
  && {
    margin-top: 2em;
  }
`;

export const Select = styled(OTSelect)`
  && {
    margin-left: 0.4em;
    ${({ addRightMargin }) => addRightMargin && 'margin-right: 0.4em;'}
  }
`;
